import { RGBAColor } from "core/math";
import { IsIOSMTags } from "./osm.interfaces";
import { OSMTagSet } from "./osm.tagset";
import { ColorResolver } from "./osm.colorResolver";
export class WaterColors {
}
WaterColors.DefaultColor = RGBAColor.blue;
WaterColors.ColorMap = new Map([
    ["lake", "blue"],
    ["lagoon", "lightblue"],
    ["pond", "@lake"],
    ["reflecting_pool", "steelblue"],
    ["reservoir", "@lake"],
    ["basin", "@lake"],
    ["river", "@lake"],
    ["fish_pass", "@lake"],
    ["oxbow", "@lake"],
    ["lock", "@lake"],
    ["moat", "@lake"],
    ["wastewater", "lightseagreen"],
    ["stream_pool", "@lake"],
]);
WaterColors.Resolver = new ColorResolver(WaterColors.DefaultColor, WaterColors.ColorMap);
export class WaterOptions {
    constructor() {
        this.color = WaterColors.DefaultColor;
        this.type = "lake";
    }
    static IsWater(record) {
        const tags = IsIOSMTags(record) ? record : new OSMTagSet(record);
        return tags.readValue("natural") === WaterOptions.waterKeyword || tags.readValue("landcover") === WaterOptions.waterKeyword;
    }
    static FromTags(record) {
        const tags = IsIOSMTags(record) ? record : new OSMTagSet(record);
        if (!this.IsWater(tags)) {
            return undefined;
        }
        const o = new WaterOptions();
        const waterType = tags.readValue("water") ?? "lake";
        o.type = waterType;
        o.color = WaterColors.Resolver.getColor(waterType);
        return o;
    }
}
WaterOptions.waterKeyword = "water";
//# sourceMappingURL=osm.interfaces.water.js.map